import { render, staticRenderFns } from "./other-locations.vue?vue&type=template&id=2a65b57a&scoped=true"
import script from "./other-locations.vue?vue&type=script&lang=js"
export * from "./other-locations.vue?vue&type=script&lang=js"
import style0 from "./other-locations.vue?vue&type=style&index=0&id=2a65b57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65b57a",
  null
  
)

export default component.exports